/* eslint-disable */

import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import { resetVideos, YTVidAutoPause } from "./chc/helpers";

document.addEventListener("alpine:init", () => {
    Alpine.data("slider", (props) => {
        let _self;
        let _refs;

        const state = {
            slider: null,
            isAccordionOpen: false,
            selectedLinkIndex: 0,
            isReady: false,
            currentSlideID: 0,
            ...props,
        };

        const sliderOptions = {
            Autoplay: {
                autoStart: state.isAutoplay,
                timeout: state.autoPlaySpeed + '000',
                showProgress: state.showProgress
            },
            Panzoom : {
                touch: props.swipe !== false
            },
            infinite: true,
            Dots: false,
            Navigation: false,
            adaptiveHeight: true,
            classes: {
                viewport: `f-carousel__viewport`,
            },
            Thumbs: {
                type: "classic",
                parentEl: document.getElementById(state.sliderId + '-thumbnails'),
                Carousel: {
                    axis: state.axis
                },
            },
            breakpoints: {
                "(max-width: 767px)": {
                    Thumbs: {
                        Carousel: {
                            axis: 'x'
                        }
                    }
                }
            }
        };

        /**
         * Update the desktop menu links according to the next selected one
         */
        function updateMenuLinksDesktop(desktopThumbnailStyle) {
            let fontStyle = `text-${state.fontStyle.titleColor}` || 'text-primary1';
            fontStyle += ' text-title-5';

            state.menuLinksStartIndex =  state.currentSlideID - Math.floor(state.linksCount / 2);
            if(state.menuLinksStartIndex < 0){
                state.menuLinksStartIndex = state.slides.length + state.menuLinksStartIndex;
            }

            state.menuLinksContainer.innerHTML = '';
            if(desktopThumbnailStyle === "infiniteLoop"){
                state.selectedLinkIndex = Math.floor(state.linksCount / 2);
                for (let i = 0; i < state.linksCount; i++) {
                    const index = (state.menuLinksStartIndex + i) % state.slides.length;
                    state.menuLinksContainer.innerHTML += `<div @click="selectLink(${i})" class="menu-links-element ${i === state.selectedLinkIndex ? "is-selected" : ""} min-h-8 font-title ${fontStyle} tracking-[-3.2px] cursor-pointer mb-6 leading-[36px]">${state.slides[index].dataset.title || "Slide&nbsp;" + index}</div>`;
                }
            } else {
                for (let i = 0; i < state.slides.length; i++) {
                    state.menuLinksContainer.innerHTML += `<div @click="selectLink(${i})" class="menu-links-element ${i === state.selectedLinkIndex ? "is-selected" : ""} min-h-8 font-title ${fontStyle} tracking-[-3.2px] cursor-pointer mb-6 leading-[36px]">${state.slides[i].dataset.title || "Slide&nbsp;" + i}</div>`;
                }
            }
        }

        /**
         * Populate the menu links for mobile view
         */
        function populateMenuLinksMobile(type) {
            state.menuLinksMobileContainer.innerHTML = '';
            state.slides.forEach((slide, i) => {
                switch (type) {
                    case "buttons":
                        state.menuLinksMobileContainer.innerHTML += `<div @click="moveSlideToID(${i}); selectMobileLinkButton(${i});" class="slider-links-mobile-button cursor-pointer mr-2 mb-2 px-4 py-3 text-center font-title inline-block text-body-3 rounded-xl hover:bg-primary1 text-primary1 hover:text-white border border-primary1">${slide.dataset.title || "Slide&nbsp;" + i}</div>`;
                        break;
                    case "hscroll":
                        state.menuLinksMobileContainer.innerHTML += `<div @click="moveSlideToID(${i}); selectMobileLinkButton(${i}); scrollToSelectedElement(${i})" class="slider-links-mobile-button cursor-pointer hover:opacity-100">${slide.dataset.title || "Slide&nbsp;" + i}</div>`;
                        break;
                    default:
                        state.menuLinksMobileContainer.innerHTML += `<div @click="moveSlideToID(${i}); toggleAccordion()" class="mb-8 last:mb-0 cursor-pointer">${slide.dataset.title || "Slide&nbsp;" + i}</div>`;
                        break;
                }
            })

            if (type === "hscroll") {
                state.menuLinksMobileScrollContainer.addEventListener('scroll', updateProgressBar);
                updateProgressBar();
            }

            selectMobileLinkButton(0);
        }

        /**
         * Update the progress bar with the mobile links with horizontal scroll style
         */
        function updateProgressBar() {
            const scrollWidth = state.menuLinksMobileContainer.scrollWidth - state.menuLinksMobileScrollContainer.clientWidth;
            if(scrollWidth <= 0 ){
                state.menuLinksMobileScrollProgressBar.classList.add('hidden');
            } else {
                state.menuLinksMobileScrollProgressBar.classList.remove('hidden');
            }
            const scrolled = state.menuLinksMobileScrollContainer.scrollLeft;
            const progress = (scrolled / scrollWidth) * 100;
            state.menuLinksMobileScrollProgressBar.style.setProperty('--progress', `${progress}%`);
        }

        function scrollToSelectedElement(selectedElementID){
            const elements = state.menuLinksMobileContainer.querySelectorAll(".slider-links-mobile-button");
            const selectedElement = elements[selectedElementID];
            selectedElement.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
        }

        /**
         * change the selected button style to highlight it
         * @param selectedSlideID
         */
        function selectMobileLinkButton(selectedSlideID) {
            state.menuLinksMobileContainer.querySelectorAll(".slider-links-mobile-button").forEach((button, i) => {
                if(i === selectedSlideID) {
                    if (state.mobileThumbnailStyle === "hscroll") {
                        button.classList.add("opacity-100");
                        button.classList.remove("opacity-20");
                    } else {
                        button.classList.add("bg-primary1", "!text-white");
                    }
                } else {
                    if (state.mobileThumbnailStyle === "hscroll") {
                        button.classList.add("opacity-20");
                        button.classList.remove("opacity-100");
                    } else {
                        button.classList.remove("bg-primary1", "!text-white");
                    }
                }
            });
        }

        /**
         * Move the menu links up by one position
         */
        function moveUp() {
            state.menuLinksStartIndex = (state.menuLinksStartIndex - 1 + state.slides.length) % state.slides.length;

            const middleIndex = Math.floor(state.linksCount / 2);
            const selectedSlideID = (state.menuLinksStartIndex + middleIndex) % state.slides.length;
            moveSlideToID(selectedSlideID);

            updateMenuLinksDesktop(state.desktopThumbnailStyle);
        }

        /**
         * Move the menu links down by one position
         */
        function moveDown() {
            state.menuLinksStartIndex = (state.menuLinksStartIndex + 1) % state.slides.length;

            const middleIndex = Math.floor(state.linksCount / 2);
            const selectedSlideID = (state.menuLinksStartIndex + middleIndex) % state.slides.length;
            moveSlideToID(selectedSlideID);

            updateMenuLinksDesktop(state.desktopThumbnailStyle);
        }

        /**
         * Select update the DESKTOP menu links according to the selected one and update the slider
         * @param {number} menuIndex - The RELATIVE index of the selected link
         */
        function selectLink(menuIndex) {
            let selectedSlideID;
            if(state.desktopThumbnailStyle === "infiniteLoop"){
                const middleIndex = Math.floor(state.linksCount / 2);
                state.menuLinksStartIndex = (state.menuLinksStartIndex + menuIndex - middleIndex + state.slides.length) % state.slides.length;
                selectedSlideID = (state.menuLinksStartIndex + middleIndex) % state.slides.length;
            } else {
                selectedSlideID = menuIndex;
                state.selectedLinkIndex = menuIndex;
            }

            moveSlideToID(selectedSlideID);
            updateMenuLinksDesktop(state.desktopThumbnailStyle);
        }

        /**
         * Move the slider to the specified slide ID
         * @param {number} slideID - The ID of the slide to move to
         */
        function moveSlideToID(slideID) {
            state.slider.slideTo(slideID);
            state.currentSlideID = slideID;

            switch (state.mobileThumbnailStyle) {
                case "buttons":
                    selectMobileLinkButton(slideID);
                    break;
                case "hscroll":
                    selectMobileLinkButton(slideID);
                    scrollToSelectedElement(slideID);
                    break;
                default:
                    toggleAccordion(false);
                    break;
            }
            updateMenuLinksDesktop(state.desktopThumbnailStyle);

            //YTVidAutoPause(_self.querySelectorAll(".f-carousel__slide"));
            resetVideos(state.videos);
        }

        /***
         * Toggle the accordion
         * @returns {void}
         */
        function toggleAccordion(forceIsOpen) {
            state.isAccordionOpen = (typeof forceIsOpen == "boolean") ? forceIsOpen : !state.isAccordionOpen;

            if (state.isAccordionOpen) {
                state.menuLinksMobileAccordion.classList.add('open');
                state.menuLinksMobileContainer.classList.remove('hidden');
                state.menuLinksMobileAccordionHeader.innerHTML = props.brandTranslation;
            } else {
                state.menuLinksMobileAccordion.classList.remove('open');
                state.menuLinksMobileContainer.classList.add('hidden');
                state.menuLinksMobileAccordionHeader.innerHTML = props.selectBrandTranslation;
            }
        }

        function onSlideChange(instance) {
            if(!state.isReady || instance.page === state.currentSlideID){
                return;
            }
            moveSlideToID(instance.page);
        }

        return {
            ...state,

            moveUp,
            moveDown,
            selectLink,
            selectMobileLinkButton,
            scrollToSelectedElement,
            moveSlideToID,
            toggleAccordion,

            init() {
                _self = this.$el;
                _refs = this.$refs;

                const sliderElm = document.getElementById(state.sliderId);
                const onEvent = {
                    on: {
                        "change": onSlideChange,
                        "selectSlide": onSlideChange,
                        ready: () => {
                            state.viewport = _self.querySelector(".f-carousel__viewport");
                            state.slides = _self.querySelectorAll(".f-carousel__slide");
                            state.videos = _self.querySelectorAll(".f-carousel__slide video");
                            this.$refs.sliderContainer.classList.remove("hidden");
                            if (state.contentWidth && state.viewport) {
                                state.viewport.classList.add(state.contentWidth);
                            }

                            // Menu links style
                            if (state.thumbnailStyle === "links") {
                                state.menuLinksUpArrow = this.$refs.menuLinksUpArrow;
                                state.menuLinksDownArrow = this.$refs.menuLinksDownArrow;
                                if (state.slides.length <= state.linksCount || state.desktopThumbnailStyle !== "infiniteLoop") {
                                    state.linksCount = state.slides.length;
                                    state.menuLinksUpArrow.classList.add('hidden');
                                    state.menuLinksDownArrow.classList.add('hidden');
                                }

                                state.menuLinksStartIndex = state.slides.length - Math.floor(state.linksCount / 2); // to start with the first slide selected
                                state.menuLinksContainer = this.$refs.menuLinksContainer;

                                state.menuLinksMobileContainer = this.$refs.menuLinksMobileContainer;

                                state.menuLinksMobileAccordion = this.$refs.menuLinksMobileAccordion;
                                state.menuLinksMobileAccordionHeader = this.$refs.menuLinksMobileAccordionHeader;

                                state.menuLinksMobileScrollContainer = this.$refs.menuLinksMobileScrollContainer;
                                state.menuLinksMobileScrollProgressBar = this.$refs.menuLinksMobileScrollProgressBar;
                                populateMenuLinksMobile(state.mobileThumbnailStyle);
                                updateMenuLinksDesktop(state.desktopThumbnailStyle);
                            }

                            state.isReady = true;
                        }
                    }
                }

                if (!state.isEditMode) {
                    let sliderPlugins = { Autoplay };
                    // Add thumbs plugin if not in links style
                    if (state.thumbnailStyle !== "links") {
                        sliderPlugins = { Thumbs, ...sliderPlugins };
                    }
                    state.slider = new Carousel(sliderElm, { ...sliderOptions, ...onEvent }, sliderPlugins);
                }
            },
        };
    });

});